export default "__VITE_ASSET__CRIZmRj1__"